module.exports = __webpack_public_path__ + "img/190220_Raumflug_Webseite.b7dbf6b5.jpg";